// extracted by mini-css-extract-plugin
export default {"listItem":"memberListItem_listItem__00xiA","assigned":"memberListItem_assigned__taNfZ","closed":"memberListItem_closed__LnfJ6"};